import {
	reMessageToAdminTypesConstants

}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : null,
	list       : null,
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reMessageToAdminTypesConstants.GetPaged.REQUEST:
		case reMessageToAdminTypesConstants.GetPagedAudit.REQUEST:
		case reMessageToAdminTypesConstants.GetPagedAll.REQUEST:
		case reMessageToAdminTypesConstants.GetList.REQUEST:
		case reMessageToAdminTypesConstants.Create.REQUEST:
		case reMessageToAdminTypesConstants.Delete.REQUEST:
		case reMessageToAdminTypesConstants.Restore.REQUEST:
		case reMessageToAdminTypesConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reMessageToAdminTypesConstants.GetPaged.FAILURE:
		case reMessageToAdminTypesConstants.GetPagedAudit.FAILURE:
		case reMessageToAdminTypesConstants.GetPagedAll.FAILURE:
		case reMessageToAdminTypesConstants.GetList.FAILURE:
		case reMessageToAdminTypesConstants.Create.FAILURE:
		case reMessageToAdminTypesConstants.Delete.FAILURE:
		case reMessageToAdminTypesConstants.Restore.FAILURE:
		case reMessageToAdminTypesConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reMessageToAdminTypesConstants.GetPaged.SUCCESS:
		case reMessageToAdminTypesConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reMessageToAdminTypesConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reMessageToAdminTypesConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reMessageToAdminTypesConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reMessageToAdminTypesConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reMessageToAdminTypesConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reMessageToAdminTypesConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reMessageToAdminTypesConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : null,
				list       : null,
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}